import {createContext} from 'react';

const ModifiedRootContext = createContext();

export default ModifiedRootContext;
